import { render, staticRenderFns } from "./LegalModal.vue?vue&type=template&id=30027811&scoped=true&"
import script from "./LegalModal.vue?vue&type=script&lang=js&"
export * from "./LegalModal.vue?vue&type=script&lang=js&"
import style0 from "./LegalModal.vue?vue&type=style&index=0&id=30027811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30027811",
  null
  
)

export default component.exports